export default __webpack_public_path__ + "images/b4cab314295666d802a82fb9c48c87d5.png";